import { Context } from '@nuxt/types'
import { RequestWithServices } from '~/server/interfaces'
import { Shops } from '~/config/shops'
import { ShopConfigQueryResult } from '~/server/services/shopConfigLoader/shopConfigLoader.types'
import { ApolloClientFactory } from '~/server/services/shopConfigLoader/ApolloClientFactory'
import {
  GetConfigOfShopConfigResponse,
  GET_CONFIG,
} from '~/server/services/shopConfigLoader/shopConfigApolloQuery'

export interface CacheContext extends Context {
  req: RequestWithServices
  shopConfigData: ShopConfigQueryResult
}

export interface Inject {
  inject: (key: string, value: ShopConfigQueryResult) => void
}

const apolloClientFactory = new ApolloClientFactory(
  process.env.GRAPGQL_URBAN_URL as string,
  [
    Shops.CZ10MA,
    Shops.HR10MA,
    Shops.HU20MA,
    Shops.PL20MA,
    Shops.PL20MA,
    Shops.SI10SI,
    Shops.SK10MA,
  ]
)

const clients = apolloClientFactory.create()

const configQuery = async (shopId: Shops): Promise<ShopConfigQueryResult> => {
  const client = clients.find((client) => client.shop === shopId)?.client

  if (client) {
    return await client
      .query({ query: GET_CONFIG })
      .then((res: GetConfigOfShopConfigResponse) => res.data.config)
  } else {
    throw new Error('🛑 ShopConfigQuery failed')
  }
}

const strategies = {
  async server(ctx: CacheContext, inject: Inject['inject']) {
    if (!ctx.req.shopConfigData) {
      // if in development server was not inicialized and no cache came from req
      ctx.req.shopConfigData = await configQuery(
        process.env.GRAPGQL_URBAN_HEADER_SHOP_ID as Shops
      )
    }
    ctx.shopConfigData = ctx.req.shopConfigData
    inject('shopConfigData', ctx.req.shopConfigData)
  },
}

export default (ctx: CacheContext, inject: Inject['inject']) => {
  if (process.server) {
    return strategies.server(ctx, inject)
  }
}
